// const releaseDate: number = 1678720335 // March 13, 2023
// const releaseDate: number = 1678897039 // March 15, 2023
// const releaseDate: number = 1679235966 // March 19, 2023
const releaseDate: number = 1679318264 // March 19, 2023

export default releaseDate
